﻿import Vue from "vue";
import Component from "vue-class-component";
import HotEditableFormManager_ from "./hotEditable/HotEditableFormManager";
import common from "../../common";
import SharedFormManager_ from "./hotEditable/SharedFormManager";
import HotEditableFormLoader_ from "./hotEditable/HotEditableFormLoader";

declare function require(module: string): unknown;
// const HotEditableFormManager = require("./hotEditable/HotEditableFormManager") as HotEditableFormManager_;
// const SharedFormManager = require("./hotEditable/SharedFormManager") as SharedFormManager_;
// const HotEditableFormLoader = require("./hotEditable/HotEditableFormLoader") as HotEditableFormLoader_;

@Component
class SecuriteUtilisateurEditVue extends Vue implements common.IHotEditableFormVue {
    showSingleDropdown1 = false;
    shared?: SharedFormManager_;
    formMode = common.HotEditableFormModes.original;
    formManager?: HotEditableFormManager_ | null;
    isVisibleToggleButton = false;
    forceUpdate = '1';
    bag = {} as any;
    _lastBagTimemoutId = null as ReturnType<typeof setTimeout> | null;

    beforeCreate() {
        const rootId = (this as any).$initialData.vueElId as string;
        HotEditableFormLoader_.prepareComponentsMarkupFromTarget(true, false, rootId).loadComponentsFromParent(this);

        this.$options.el = '#' + rootId;

        this.formManager = new HotEditableFormManager_(this, (this as any).$initialData.formName as string | null);
        this.shared = new SharedFormManager_(this.formManager);
    }

    created() { }

    mounted() {
        //this.formManager.setupForm();
    }

    // setActionConfirmation(key: string, arg1: () => void) {
    //     throw new Error("Method not implemented.");
    // }

    // /** Met à jour le UI avec la liste des rôles sélectionnés provenant du serveur */
    // updateSelectedRoles(selectedRoleCodes: string[]) {
    //     const checkboxes = this.formManager.getCheckboxes() as HotEditableCheckboxComponent[];
    //     checkboxes.forEach(x => {
    //         const checked = selectedRoleCodes.indexOf(x.elementName) >= 0;
    //         x.check(checked, false);
    //     });
    // }

    getFromBag(key: string) {
        const r = this.bag[key];
        return r || r === false || r === 0 || r === '' ? r : null;
    }

    setToBag(key: string, value?: any, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        delayMs = delayMs || 0;
        forceDelayedSetToBeExecuted = forceDelayedSetToBeExecuted === true;
        const f = () => { this.$set(this.bag, key, value || value === false || value === 0 || value === '' ? value : ''); }
        if (!forceDelayedSetToBeExecuted && this._lastBagTimemoutId) {
            clearTimeout(this._lastBagTimemoutId);
            this._lastBagTimemoutId = null;
        }

        if (delayMs)
            this._lastBagTimemoutId = setTimeout(f, Math.max(0, Math.min(15000, delayMs)));
        else
            f();
        return this;
    }
    getBooleanFromBag(key: string, defaultValue?: boolean) {
        const val = this.getFromBag(key);
        if (val === true || val === false)
            return val;
        return defaultValue ?? false;
    }
    setBooleanToBag(key: string, value: boolean, delayMs?: number, forceDelayedSetToBeExecuted?: boolean) {
        this.setToBag(key, value === true, delayMs, forceDelayedSetToBeExecuted);
        return this;
    }
    updateBagWhere(whereClause: (key: string, val?: any) => boolean, value?: any) {
        if (whereClause)
            for (let k in this.bag)
                if (whereClause(k, this.bag[k]))
                    this.bag[k] = value;
    }
    updateBagWhereKeyStartWith(startWith: string, value?: any, excludedKeys?: string | string[]) {
        if (!startWith) return;
        excludedKeys = excludedKeys || [];
        if (!Array.isArray(excludedKeys))
            excludedKeys = [excludedKeys];
        const isExcluded = (x: string) => {
            if (x)
                for (let i = 0; i < excludedKeys.length; i++)
                    if (excludedKeys[i] === x)
                        return true;
            return false;
        };
        this.updateBagWhere(k => !isExcluded(k) && k.startsWith(startWith), value);
    }

    updateBag(updated?: common.IBag) {
        if (!updated)
            return this;
        var isUpdated = false;
        if (updated && updated.raw)
            for (let k in updated.raw) {
                this.bag[k] = updated.raw[k];
                if (!isUpdated)
                    isUpdated = true;
            }

        if (isUpdated)
            this.$forceUpdate();
        return this;
    }
}

export = SecuriteUtilisateurEditVue;
